// extracted by mini-css-extract-plugin
export default {"newConnectionContractorsFormItem":"styles_new-connection-contractors-form-item__fSNcu"};